export const DEFAULT_DOMAIN = "feedvote.app";

export function normalizeDomain(domain: string | undefined): string {
  const trimmed = domain?.trim();
  if (!trimmed) return DEFAULT_DOMAIN;
  return trimmed.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
}

export function getRootDomain(): string {
  return normalizeDomain(process.env.NEXT_PUBLIC_ROOT_DOMAIN);
}

export function getSiteUrl(): string {
  const domain = getRootDomain();
  const protocol =
    domain.includes("localhost") || domain.includes("127.0.0.1")
      ? "http"
      : "https";
  return `${protocol}://${domain}`;
}

export function getMetadataBase(): URL {
  return new URL(getSiteUrl());
}

export function buildBoardUrl(subdomain: string): string {
  const rootDomain = getRootDomain();
  const protocol =
    rootDomain.includes("localhost") || rootDomain.includes("127.0.0.1")
      ? "http"
      : "https";
  const cleanSubdomain = subdomain.trim();
  return cleanSubdomain
    ? `${protocol}://${cleanSubdomain}.${rootDomain}`
    : `${protocol}://${rootDomain}`;
}
